import { CloseSidePanelAction, FamilyTreeActionFn } from '../types';

export const closeSidePanelAction: FamilyTreeActionFn<CloseSidePanelAction> = (
  state
) => {
  return {
    ...state,
    selectedPersonId: undefined,
    isSidePanelOpen: false,
    sidePanelVariant: undefined,
  };
};
